import React from "react";
import OwlCarousel from "react-owl-carousel";

import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

const brandLogos = [
 {
  src: "./images/logos/brandlogos/Audi.png",
  alt: "Audi",
},
{
  src: "./images/logos/brandlogos/BYD.png",
  alt: "BYD",
},
{
  src: "./images/logos/brandlogos/TVS.png",
  alt: "TVS",
},
{
  src: "./images/logos/brandlogos/Gulf.png",
  alt: "Gulf",
},
{
  src: "./images/logos/brandlogos/VERTIV.png",
  alt: "VERTIV",
},
{
  src: "./images/logos/brandlogos/SecoTools.png",
  alt: "Seco Tools",
},
{
  src: "./images/logos/brandlogos/McDonald's.png",
  alt: "Mc Donald's",
},
{
  src: "./images/logos/brandlogos/Ceat.png",
  alt: "Ceat",
},
{
  src: "./images/logos/brandlogos/Trends.png",
  alt: "Trends",
},
{
  src: "./images/logos/brandlogos/Skoda.png",
  alt: "Skoda",
},
{
  src: "./images/logos/brandlogos/Porsche.png",
  alt: "Porsche",
},
{
  src: "./images/logos/brandlogos/RoayalEnfield.png",
  alt: "Roayal Enfield",
},
{
  src: "./images/logos/brandlogos/AMO.png",
  alt: "AMO",
},
{
  src: "./images/logos/brandlogos/LensKart.png",
  alt: "LensKart",
},
{
  src: "./images/logos/brandlogos/ITC.png",
  alt: "ITC",
},
{
  src: "./images/logos/brandlogos/MercedesBenz.png",
  alt: "Mercedes Benz",
},
{
  src: "./images/logos/brandlogos/Blackberrys.png",
  alt: "Blackberrys",
},
{
  src: "./images/logos/brandlogos/JohnJacobs.png",
  alt: "John Jacobs",
},
{
  src: "./images/logos/brandlogos/Indriya.png",
  alt: "Indriya",
},
{
  src: "./images/logos/brandlogos/AllenSolly.png",
  alt: "Allen Solly",
},
{
  src: "./images/logos/brandlogos/EurekaForbes.png",
  alt: "Eureka Forbes",
},
{
  src: "./images/logos/brandlogos/Dabur.png",
  alt: "Dabur",
},
{
  src: "./images/logos/brandlogos/Zee5.png",
  alt: "Zee 5",
},
{
  src: "./images/logos/brandlogos/Joyalukkas.png",
  alt: "Joyalukkas",
},
{
  src: "./images/logos/brandlogos/TheFaceShop.png",
  alt: "The Face Shop",
},
{
  src: "./images/logos/brandlogos/Minifeel.png",
  alt: "Minifeel",
},
];

const carouselOptions = {
  loop: true,
  margin: 10,
  dots: false,
  nav: false,
  autoplay: true,
  autoplayTimeout: 2000,
  autoplayHoverPause: false,
  smartSpeed: 1000,
  responsiveClass: true,
  responsive: {
    0: {
      items: 2,
    },
    600: {
      items: 3,
    },
    1000: {
      items: 5,
    },
  },
};

const outerContainerStyle = {
  backgroundColor: "#F0EBE3",
  padding: "20px 0",
  overflow: "hidden",
  transform: "scaleX(-1)",
};
const itemStyle = {
  transform: "scaleX(-1)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};
const imageStyle = {
  width: "170px",
  height: "auto",
  objectFit: "contain",
};

const VMBrandLogos = () => {
  return (
    <div style={outerContainerStyle}>
      <OwlCarousel className="owl-theme" {...carouselOptions}>
        {brandLogos.map(({ src, alt }, index) => (
          <div key={index} className="item" style={itemStyle}>
            <div className="featured-imagebox featured-imagebox-service style2">
              <div className="featured-thumbnail d-flex justify-content-center px-3">
                <img src={src} alt={alt} style={imageStyle} />
              </div>
            </div>
          </div>
        ))}
      </OwlCarousel>
    </div>
  );
};

export default VMBrandLogos;